module.exports = __webpack_public_path__ + "static/img/ProcessLicm.1f9e33c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ProcessLicm.jpg
// module id = IM/c
// module chunks = 1